import ImageOptimizer from '@/components/image-optimizer';
import type { PopupBannerData } from '@/types/popup-banner.type';

interface PopupBannerCardProps {
  data: PopupBannerData;
}

export default function PopupBannerCard({ data }: PopupBannerCardProps) {
  return (
    <div className="w-full overflow-hidden rounded-t-2xl">
      <div className="text-center">
        {/* <div className="typo-20 mb-2 font-bold">{data.subtitle}</div>
        <div className="typo-24 mb-2 font-bold text-blue-600">{data.title}</div>
        <div className="typo-14 text-gray-600">{data.description}</div> */}
        <div className="relative aspect-[460/480] h-auto w-full">
          <ImageOptimizer
            src={data.imageSrc}
            alt={data.description || '팝업 배너'}
            fill
            className="object-cover"
          />
        </div>
      </div>
    </div>
  );
}
